module.exports = __webpack_public_path__ + "static/media/mtn_landing_page_desktop_2023.ff60f732.jpg";